import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { add } from "../../../service/clientService";
import { Button } from 'primereact/button';
import DropdownApi from '../../../components/DropdownApi';
import { UserSession } from '../../../models/UserSession';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { addEmployee, updateEmployee } from '../../../service/employeeService';
import { NprLookup } from '../../../service/api-service';
import S3ImagePreview from '../../../components/S3ImagePreview';
import { Avatar } from 'primereact/avatar';
import { placeholder } from '../../../assets/placeholder';
import MultiDropdownApi from '../../../components/MultiDropdownApi';
import { siteEmployeeAdd, siteEmployeeUpdate } from '../../../service/siteService';



export default function EmployeeSiteAdd(modalProps: any) {

  const record = modalProps.record;

  const employee = modalProps.employee;

  async function EmployeeAdd() {
    let createObject: any = {
      employee,
      appointment,
      siteId: site
    };
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      siteEmployeeUpdate(createObject, record.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'Employee Updated Successfully', life: 3000 });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      });
      return;
    }
    siteEmployeeAdd(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({ severity: 'success', summary: 'Employee Added Successfully', life: 3000 });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    })
  }

  const [appointment, setAppointment] = React.useState(record?.appointment || "");
  const [site, setSite] = React.useState(record?.site || "");

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <DropdownApi apiPath='site-list' optionLabel="name" optionValue='id' label='Site' selectedData={site}
                         setSelectedData={setSite}
                         disabled={record?.id ? true : false}
            />
          </Stack>
          <Stack spacing={1}>
            <MultiDropdownApi apiPath='appointments' queryParams={{ employeeId: employee }}
                              optionLabel="name" optionValue='id' label='Appointment' selectedData={appointment}
                              setSelectedData={setAppointment} />
          </Stack>
        </Stack>
      </Stack>
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => EmployeeAdd()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}